const SET_USER_DEFAULTS = (state, payload) => {
  state.user = payload.user;
  state.usageEventsDisabled = payload.usageEventsDisabled;
};

export default SET_USER_DEFAULTS;
